// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AVATAR_AGE__age_major_AND_age_minor = "%(age_major)s a %(age_minor)s";
export const AVATAR_AGE__EXACTLY_age = "p\u0159esn\u011b %(age)s";
export const number_DAYS = ["%(number)s den", "%(number)s dny", "%(number)s dn\u016f"];
export const number_MONTHS = ["%(number)s m\u011bs\u00edc", "%(number)s m\u011bs\u00edce", "%(number)s m\u011bs\u00edc\u016f"];
export const number_WEEKS = ["%(number)s t\u00fdden", "%(number)s t\u00fddny", "%(number)s t\u00fddn\u016f"];
export const number_YEARS = ["%(number)s rok", "%(number)s roky", "%(number)s let"];
